module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "layout"
    }
  }, [_c('h1', [_vm._v("Trek or Tweet")]), _vm._v(" "), _c('h2', [_vm._v("Get it wrong and go for a walk "), _c('sup', [_vm._v("or else...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-32b5688a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Layout.vue
// module id = 87
// module chunks = 0